<div class="modal-body" id="project-invoice">
  <ag-grid-angular
      #topGrid
      style="height:240px;"
      class="ag-theme-alpine pps-top-grid"
      [context]="context"
      [rowData]="invoices"
      [columnDefs]="gridHeaders"
      [gridOptions]="topOptions"
      (gridReady)="onTopGridReady($event)"
      [rowSelection]="{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }">
  </ag-grid-angular>
  <ag-grid-angular
      #bottomGrid
      style="height: 34px;"
      class="ag-theme-alpine pps-bottom-grid"
      [headerHeight]="0"
      [context]="context"
      [rowData]="invoiceTotal"
      [columnDefs]="gridHeaders"
      [gridOptions]="bottomOptions"
      (gridReady)="onBottomGridReady($event)"
      [rowStyle]="{ fontWeight: 'bold', backgroundColor: '#eeeeee'}"
      [rowSelection]="{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }">
  </ag-grid-angular>
</div>

<div class="modal-footer">
  <button pButton pRipple label="Close" class="p-button" icon="pi pi-times" type="button" (click)="cancel()"></button>
</div>
